<template>    
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">                
                <div class="card mb-5">
                    <div class="card-header p-3 pt-2">
                        <div class="icon icon-lg icon-shape shadow text-center border-radius-xl mt-n4 position-absolute bg-gradient-success shadow-dark">
                            <i class="material-symbols-rounded opacity-10 text-white" aria-hidden="true">location_on</i>
                        </div>
                        <h6 class="mb-2" style="margin-left: 4.5rem !important;">{{ $t('location.Locations') }}</h6>
                        <div class="row" style="margin-top: -30px;">
                            <div class="col-lg-6">
                            </div>
                            <div class="col-lg-6 d-flex justify-content-end align-items-center gap-2">
                                <div class="btn-group" v-if="userRoleName == 'AssociationAdmin'">
                                    <router-link
                                        :to="associationId ? { name: 'New Location', params: { id: associationId } } : ''"
                                        class="btn btn-sm bg-gradient-success text-nowrap"
                                        :class="{ disabled: !associationId }"
                                        style="width: 150px;"
                                    >
                                        {{ $t('location.Add_location') }}
                                    </router-link>
                                </div>
                                <div class="btn-group" v-if="userRoleName == 'Admin'">                                    
                                    <router-link
                                        :to="associationId ? `/location/create/${associationId}` : '#'"
                                        class="btn btn-sm bg-gradient-success text-nowrap"
                                        :class="{ disabled: !associationId }"
                                        style="width: 150px;"
                                    >
                                        {{ $t('location.Add_location') }}
                                    </router-link>

                                    <!-- Dropdown toggle -->
                                    <button type="button" class="btn btn-sm bg-gradient-success dropdown-toggle dropdown-toggle-split"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    <span class="visually-hidden">{{ $t('settings.Select_association') }}</span>
                                    </button>
                                    <!-- Dropdown menu -->
                                    <ul class="dropdown-menu dropdown-menu-end  custom-association-dropdown">
                                        <li @click="associationId = ''">
                                            <span class="dropdown-item text-muted">
                                            {{ $t('settings.Select_association') }}
                                            </span>
                                        </li>
                                        <li><hr class="dropdown-divider" /></li>
                                        <li v-for="item in associations" :key="item.id" @click="associationId = item.id" class="dropdown-item">
                                            {{ item.abbreviation }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table id="location-list" class="table table-flush" :key="locationKey">
                            <thead class="thead-light">
                                <tr>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('location.UBN_number') }}</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('location.Name') }}</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('location.Address') }}</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('location.Animals') }}</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('location.Active_animals') }}</p></th>
                                    <!--th><p class="mb-0 text-xs font-weight-bold">{{ $t('location.ToilerDiseaseFree') }}</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('location.ScrapieCertificate') }}</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('location.RVO') }}</p></th-->
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="location in locations" v-bind:key="location.id">
                                    <td class="text-sm font-weight-normal">
                                        {{ location.ubn }} <br />
                                        {{ $t('animal.Association') }}: {{ location.associationAbbreviation }}
                                    </td>
                                    <td class="text-sm font-weight-normal">{{ location.name }}</td>                                         
                                    <td class="text-sm font-weight-normal" v-html="location.locationFullAddress"></td>                           
                                    <td class="text-sm font-weight-normal">                                        
                                        <i class="material-symbols-rounded opacity-10 font-size-14" 
                                            :class="location.hasAnimals ? 'text-success' : 'text-danger'"
                                            aria-hidden="true">
                                            {{ location.hasAnimals ? 'thumb_up' : 'thumb_down' }}
                                        </i>
                                    </td>
                                    <td class="text-sm font-weight-normal">{{ location.animalCount }}</td>
                                    <!--td class="text-sm font-weight-normal">
                                        <i class="material-symbols-rounded opacity-10 font-size-14" 
                                            :class="location.isToilerDiseaseFree ? 'text-success' : 'text-danger'"
                                            aria-hidden="true">
                                            {{ location.isToilerDiseaseFree ? 'thumb_up' : 'thumb_down' }}
                                        </i>
                                    </td>                                        
                                    <td class="text-sm font-weight-normal">
                                        <i class="material-symbols-rounded opacity-10 font-size-14" 
                                            :class="location.hasScrapieCertificate ? 'text-success' : 'text-danger'"
                                            aria-hidden="true">
                                            {{ location.hasScrapieCertificate ? 'thumb_up' : 'thumb_down' }}
                                        </i>
                                    </td>
                                    <td class="text-sm font-weight-normal">
                                        <i class="material-symbols-rounded opacity-10 font-size-14" 
                                            :class="location.isRvoVerified ? 'text-success' : 'text-danger'"    
                                            aria-hidden="true">
                                            {{ location.isRvoVerified ? 'thumb_up' : 'thumb_down' }}
                                        </i>
                                    </td-->
                                    <td>                                        
                                        <div class="float-end">
                                            <button :data-id="location.id" class="mt-2 mb-0 btn btn-sm bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 report-button" style="margin-right: 10px !important;" :title="$t('animal.Stablelist')">
                                                <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;">download</i> {{ $t('animal.Stablelist')}}
                                            </button>
                                            <button :data-id="location.id" class="mt-2 mb-0 btn btn-sm bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 invullijst-button" style="margin-right: 10px !important;" :title="$t('animal.Stablelist1')">
                                                <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;">download</i> {{ $t('animal.Stablelist1')}}
                                            </button>
                                            <button :data-id="location.id" class="mt-2 mb-0 btn btn-sm bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 preview-button" style="margin-right: 10px !important;" :title="$t('common.Details')">
                                                <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">preview</i>
                                            </button>
                                            <button v-show="userRoleName === 'Admin' || userRoleName === 'AssociationAdmin'" :data-id="location.id" class="mt-2 mb-0 btn btn-sm bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 edit-button" style="margin-right: 10px !important;" :title="$t('common.Edit')">
                                                <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">edit</i>
                                            </button>
                                            <button v-show="userRoleName === 'Admin' || userRoleName === 'AssociationAdmin'" :disabled="location.animalCount>0" :data-id="location.id" class="mt-2 mb-0 btn bg-gradient-danger btn-sm ms-lg-auto me-lg-0 me-auto mt-lg-0 delete-button" :title="$t('common.Delete')">
                                                <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">delete</i>
                                            </button>                                            
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>        
</template>

<script>
import axios from 'axios';
import { nextTick } from 'vue';
import { DataTable } from "simple-datatables";

export default {
    name: 'Location_index_page',
    components: {
    },
    data() {
        return {
            associationId: '',
            associations: [],
            locations: [],
            gets: [],            
            dataTableInstance: null,
            locationKey:0,
        }
    },
    computed: {    
        userRoleName() {
            return this.$store.state.user?.roleName;
        }        
    },
    async mounted() {
        try {
            
            this.$store.commit('setShowLoading', true);

            const role = this.userRoleName;
            const keeperLocationId = this.$store.state.keeperLocationId;
            const associationAdminAssociationId = this.$store.state.associationAdminAssociationId;

            let response;

            if (role === 'Admin') {
                await this.fetchAllAssociationData();
                response = await axios.get('Location/getall');
            } else if (role === 'AssociationAdmin') {                  
                this.associationId = associationAdminAssociationId;

                response = await axios.get("Location/getallbyassociation", {
                    params: {
                        associationId: this.associationId
                    }
                });                                                             
            } else if (role === 'Keeper' && keeperLocationId) {
                response = await axios.get("Location/getall?id=" + this.$store.state.user.id);
            } else {
                // Optional: handle case where Keeper has no location selected
                console.warn('No location assigned for Keeper');
                return;
            }
            
            this.gets = response.data;

            if (this.gets.success) {                   
                if(this.gets.data != null) {
                    if (role === 'Admin') {
                        this.locations = this.gets.data.locationList.sort((a, b) => {
                            // First, compare by associationAbbreviation
                            if (a.associationAbbreviation < b.associationAbbreviation) return -1;
                            if (a.associationAbbreviation > b.associationAbbreviation) return 1;

                            // If equal, compare by ubn
                            if (a.ubn < b.ubn) return -1;
                            if (a.ubn > b.ubn) return 1;

                            return 0;
                        });
                    } else {
                        this.locations = this.gets.data.locationList;
                    }                    
                }
            } else {
                this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }

        await nextTick();   // Wait until the DOM is updated

        this.initDataTable();
        
        this.$store.commit('setShowLoading', false);
    },
    methods: {   
        selectAssociation(associationId) {
            //alert(associationId);
            this.associationId = associationId
        },
        async fetchAllAssociationData() {
            try {
                const response = await axios.get("association/getall");
                const result = response.data;

                if (result.success && Array.isArray(result.data.associationList)) {
                    this.associations = result.data.associationList;
                } else {
                    this.$showError('errors.Error_fetching_associations');                    
                }                
            } catch (e) {                    
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }
        },
        async initDataTable() {
            
            const table = document.querySelector("#location-list");
            // Defensive check to prevent "parent is null"
            if (!table || !table.parentNode) {
                console.warn("Table or its parent not found. Skipping DataTable init.");
                return;
            }

            if (this.dataTableInstance) {
                this.dataTableInstance.destroy();
            }

            await nextTick();   // Wait until the DOM is updated

            this.dataTableInstance = new DataTable("#location-list", {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,
                //perPage: 1, // Set the default number of records per page
                //perPageSelect: [5, 10, 20, 50], // Adds a dropdown with options            
                columns: [
                    { select: 0, sortable: true },
                    { select: 1, sortable: true },
                    { select: 2, sortable: true },
                    { select: 3, sortable: true },
                    { select: 4, sortable: true },                    
                    { select: 5, sortable: false }  // Action column (index 10) - Disable sorting
                ],
                labels: {
                    search: this.$t('datatable.Search'),  // Translate "Search..."
                    perPage: this.$t('datatable.PerPage'),  // Translate "{select} entries per page"
                    noRows: this.$t('datatable.NoRows'),  // Translate "No entries to show"
                    info: "Tonen {start} t/m {end} van {rows} items",  // Translate "Showing {start} to {end} of {rows} entries"
                    placeholder: this.$t('common.Search') 
                }
            });  

            table.addEventListener('click', this.handleTableClick);
        },  
        handleTableClick(event) {
            const targetElement = event.target.closest('[data-id]');
            if (!targetElement) return;

            const id = targetElement.getAttribute('data-id');
            if (!id) return;

            if (event.target.closest('.edit-button')) {
                this.$router.push({ name: 'Edit Location', params: { id } });
            } else if (event.target.closest('.preview-button')) {
                this.$router.push({ name: 'Preview Location', params: { id } });
            } else if (event.target.classList.contains('delete-button')) {
                this.deleteLocation(id);
            }  else if (event.target.closest('.report-button')) {
                this.$router.push({ name: 'Report Stablelist', params: { id } });
            } else if (event.target.closest('.invullijst-button')) {
                this.$router.push({ name: 'Report Invullijst', params: { id } });
            }
        },
        async deleteLocation(id) {   
            this.$swal
                .fire({
                    text: this.$t('common.Are_you_sure_to_delete_this_record'),
                    //icon: "error",
                    cancelButtonText: this.$t('common.Cancel'),
                    confirmButtonText: this.$t('common.Confirm_Delete'),
                    showCancelButton: true,
                    position: 'top-end'
                })
                .then(async (result) => {
                    if (result["isConfirmed"]) {                        
                        try {
                            
                            this.$store.commit('setShowLoading', true);

                            const response = await axios.delete("Location/" + id);
                            this.gets = response.data;

                            if (this.gets.success) {
                                try {
                                    
                                    const fetchResponse = await axios.get("Location/getall");
                                    const fetchResult = fetchResponse.data;

                                    if (fetchResult.success) {                                        
                                        this.locations = fetchResult.data.locationList;
                                        this.locationKey++;

                                        // Destroy the existing instance
                                        if (this.dataTableInstance) {
                                            this.dataTableInstance.destroy();
                                            this.dataTableInstance = null;
                                        }

                                        await nextTick(); // Wait for DOM update

                                        // Re-initialize the DataTable
                                        this.initDataTable();
                                        
                                        this.$showSuccess('errors.Success_record_is_deleted_successfully');                                        
                                    } else {
                                        throw new Error('Failed to fetch updated location list.');
                                    }
                                } catch (e) {
                                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                                }
                            } else {                                    
                                this.$showError('errors.Contact_system_admin');
                            }                            
                        } catch (e) {
                            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                        }
                        
                        this.$store.commit('setShowLoading', false);                        
                    }
                });            
        }
    }
}
</script>
<style scoped>
    ::v-deep .choices {
        width: auto !important;
        min-width: 270px;
    }

    .custom-association-dropdown {        
        border: 1px solid #4ca750;
    }

    ::v-deep(.table tbody tr:hover) {
        background-color: #f0f2f5 !important;;
        color: #333 !important;;
        transition: background-color 0.2s ease-in-out !important;;
    }

    /* Ensure the top container uses flex layout */
    ::v-deep .dataTable-top {
        display: flex !important;
        justify-content: flex-start !important;
        align-items: center !important;
    }

    /* Specifically target the search box to stay left aligned */
    ::v-deep .dataTable-top .dataTable-search {
        margin-right: auto !important;
        width: 50% !important;
    }

    ::v-deep .dataTable-top .dataTable-search .dataTable-input {
        width: 100% !important;
    }

    ::v-deep .dataTable-wrapper .dataTable-top .dataTable-search input {
        border: 1px solid #d2d2d2 !important;
    }

    /* Adjust the dropdown positioning (if present) */
    ::v-deep .dataTable-top .dataTable-dropdown {
        margin-left: 10px !important;
    }

    .font-size-14 {
        font-size: 14px !important;
    }
</style>